// extracted by mini-css-extract-plugin
export var arrow = "_39-6";
export var changeItem = "_39-3";
export var changesHeader = "_39-1";
export var changesList = "_39-2";
export var container = "_39-0";
export var pathLabel = "_39-4";
export var value = "_39-7";
export var valuesContainer = "_39-5";